module.exports = __webpack_public_path__ + "img/Sheep.643ec177.png";